import React from "react";

export const letter =
  "Thank you for using our claims portal to report your claim.";
export const letterToAnonymousClaimant =
  "Thank you for using our claims portal to report your claim.";
export const prompt =
  "Let's start by gathering some details about what happened. This should only take a few minutes.";
export const autoDescription =
  "This includes physical damage to your vehicle because of an accident or event.";
export const glassDescription =
  "Damage to glass windows on your vehicle including cracks and chips";
export const wcDescription = "This includes a work-related injury or illness.";
export const propertyDescription =
  "This includes claims at your workplace in which you suffered a loss.";
export const liabilityDescription =
  "This includes claims at your workplace that involve a third-party loss.";
export const homeDescription =
  "Damage to your home or other personal property covered under your policy";
export const autoGlassReport =
  "Reporting your Auto Glass claim online is easy, just select your policy and provide the required information.";
export const autoGlassQuestion =
  "Should I have my windshield repaired? View common break patterns.";
export const formAutoError =
  "Unable to Fetch Auto Details at this time, Please try again later";
export const formStateError =
  "Unable to Fetch State Details at this time, Please try again later";
export const formCodeError =
  "Unable to Fetch Location Code Details at this time, Please try again later";
export const formCountyError =
  "Unable to Fetch County Details at this time, Please try again later";
export const yearLengthError = "Year must be in long format";
export const formSubmissionError =
  "Unable to Submit the Form at this Time. Please try again later";
export const policiesFetchError =
  "Unable to Fetch Policy Details at this time, Please try again later";
export const propertyFetchError =
  "Unable to Fetch Property Details at this time, Please try again later";
export const claimsFetchError =
  "Unable to Fetch Claims Details at this time, Please try again later";
export const claimSummaryFetchError =
  "Unable to Fetch Claim Details at this time, Please try again later";
export const genericError = "Something went wrong";
export const validationError = "Please fill out all required fields";
export const emailConfirmationError = "Emails do not match.";
export const fileSizeError = "Total files size exceeds the allowable limit";
export const fileLimitError = "File count exceeds the allowable limit";
export const codeSuccess = "Your code has been sent";
export const codeFailure = "An error has occurred. Please try again.";
export const policyInputValidation = "Invalid policy number";
export const nostatusesValidation = "At least one status must be selected";
export const noagenciesValidation = "An agency must be selected";
export const authorizationError =
  "Policy number is incorrect or user is not authorized to view it.";
export const noSpecialCharacters = "Input may not contain special characters.";
export const driverightTitle = "DriveSteady Activation Code";
export const invalidNumber = "Invalid Cell Phone Number";
export const footerText_line1 =
  "Utica Mutual Insurance Company, its affiliates and subsidiaries, 180 Genesee St., New Hartford, NY 13413";
const year = new Date().getFullYear();
export const footerText_line2 = `${year} Copyright Utica Mutual Insurance Company`;
export const baseTitle = "Utica National";
export const dateError = "Please enter a valid date.";
export const alphabeticError = "Only alphabetic characters are allowed";
export const numericError = "Only numbers allowed";
export const phoneError =
  "Invalid phone number (please remove any dashes, parentheses, or spaces)";
export const zipError = "ZIP Code should be a 5-digit number";
export const noDecimalsError = "Decimals are not allowed";
export const decimalPlaces2Error =
  "No more than 2 digits are allowed after the decimal";
export const decimalPlaces1Error = "Only 1 digit is allowed after the decimal";
export const requiredError = "Answer is required";
export const noWitnesses = "No witnesses added";
export const noDocuments = "No documents uploaded";
export const apiFailureError = "Something went wrong. Please try again later";
export const mandatoryFieldsMessage = "Fields marked with (*) are required";
export const witnessMessage =
  'Please click "Remove Witness $" if there is no information for this witness';
export const emailError = "Invalid email";
export const claimsMailBox = "HomeOfficeClaimsMailbox@UticaNational.com";
export const dateTimeError = "Please enter a date and time in this format: MM/DD/YYYY HH:MM am/pm";
export const dateFormatError = "Please enter a date in this format: MM/DD/YYYY";
export const yearError = "Please enter a valid year ex: 2020";
export const freeFormSpecialCharsError = "No special characters are allowed other than standard punctuation symbols. (You may receive this error after copying from a Word document. Please retype any hyphens or apostrophes.)";
